import { type FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Body1, Box, Card, Divider, H6, Stack, StackColumn } from '@dhl-ui/components'
import { DhlLogo } from '@dhl/icons'
import { type Servicepoint, ServicepointMap, ServicepointOpeningTimes } from '@dhl/receiver-servicepoint'
import { AddressLines } from '@dhl/components'

type ServicepointDetailsProps = {
  servicepoint: Servicepoint
}

export const ServicepointDetails: FC<ServicepointDetailsProps> = ({ servicepoint }) => {
  const { t } = useTranslation()

  return (
    <Card withPaddingBottom withPaddingTop>
      <Card.Header title={t('portal.profile.preferences.setupPage.servicePoint.detailsCardTitle')} />
      <Card.Content noPaddingSides>
        <StackColumn>
          <Stack spacing={3}>
            <Box px={2}>
              <ServicepointMap servicepoint={servicepoint} />
            </Box>
            <Stack direction="row" px={2} spacing={2}>
              <DhlLogo sx={{ width: 40, height: 40 }} />

              <Stack>
                <H6>{servicepoint?.name}</H6>
                <Body1>
                  <AddressLines address={servicepoint?.address} singleLine />
                </Body1>
              </Stack>
            </Stack>
          </Stack>

          <Divider />

          <Stack px={2} spacing={3}>
            <Stack spacing={1}>
              <H6>{t('portal.profile.preferences.setupPage.servicePoint.openingTimes')}</H6>

              <ServicepointOpeningTimes openingTimes={servicepoint.openingsTimes} />
            </Stack>
          </Stack>
        </StackColumn>
      </Card.Content>
    </Card>
  )
}
